import { FormData, SelectOption } from "../../Components/common/types";
import { baseURL, sendEmail } from "../../config/variables";
//Generics are used to make it adapt to diffrent forms
type PartialFormData<T extends keyof FormData> = Pick<FormData, T>;

interface HandleSubmitOptions<T extends keyof FormData> {
  formData: PartialFormData<T>;
  validateWrapper: () => boolean;
  showLoader?: (isLoading: boolean) => void;
  showAlert: (
    isError: boolean,
    title: string,
    message: string,
    isTwoButtons: boolean
  ) => void;
  setFormData: (data: PartialFormData<T>) => void;
  setTouched: (touched: Record<T, boolean>) => void;
}

export const handleFormSubmit = async <T extends keyof FormData>({
  formData,
  validateWrapper,
  showLoader,
  showAlert,
  setFormData,
  setTouched,
}: HandleSubmitOptions<T>) => {
  showLoader?.(true);

  if (!validateWrapper()) {
    showLoader?.(false);
    showAlert(
      true,
      "Submission Error",
      "Please fill in all required fields.",
      false
    );
    return;
  }

  // console.log("Form data", formData);
  const emailData = {
    ...formData,
    service:
      "service" in formData && Array.isArray(formData.service) //check if service exist since its Partial
        ? formData.service?.map((s: SelectOption) => s.label).join(", ")
        : "",
  };
  // console.log('Email Data:',emailData);

  try {
    const endpoint = baseURL + sendEmail;
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(emailData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      showAlert(true, "Error", errorData.message, false);

      return;
    }

    const data = await response.json();
    // Hide loader once submission is complete
    showLoader?.(false);
    showAlert(false, "Success!", data.message, false);

    // Reset form(field present) if the submission is successful
    //acc => accumulator for reduce, object to be reduced
    const resetData = Object.keys(formData).reduce((acc, key) => {
      // Check if the field is an array or string with a guard function
      function getResetValue(field: unknown): unknown {
        if (Array.isArray(field)) return [];
        return "";
      }
      acc[key as T] = getResetValue(formData[key as T]) as FormData[T];
      return acc;
    }, {} as PartialFormData<T>);

    setFormData(resetData);

    //set fields to unfocused (field presents)
    const touchedFields = Object.keys(formData).reduce((acc, key) => {
      acc[key as T] = false;
      return acc;
    }, {} as Record<T, boolean>);

    setTouched(touchedFields);
  } catch (error) {
    // Hide loader on failure
    showLoader?.(false);
    showAlert(
      true,
      "Error",
      `An unknown error occured`,
      false
    );
  } finally {
    // Hide loader regardlessly
    showLoader?.(false);
  }
};
